import React, { Component } from 'react';
import terms from './../terms-and-conditions.js';

class TermsConditions extends Component {
	componentWillMount() {
		terms.setTermsAndConditionsPageActive(true);
	}

	componentWillUnmount() {
		terms.setTermsAndConditionsPageActive(false);

	}

	render() {
		return (
			<div id="terms-conditions" />
		);
	}
}

export default TermsConditions;



// WEBPACK FOOTER //
// ./mobile-core/src/components/terms-conditions.js